import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-dialog',
  standalone: false,
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  dialogTitle: string;
  dialogMessage: string;
  acceptButtonLabel: string = 'Yes';
  cancelButtonLabel: string = 'No';

  constructor(private modal: NgbActiveModal) { }

  accept() {
    this.modal.close();
  }

  cancel() {
    this.modal.dismiss();
  }
}
